import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { useSubmitToTalentCommittee } from '@/queries/useAppraisalDetail';

interface SubmitToTalentCommitteeDialogProps {
  open: boolean;
  onClose: () => void;
  appraisalId: string;
  rowVersion?: string;
  onSuccess: () => void;
  onError: (error: unknown) => void;
}

export function SubmitToTalentCommitteeDialog({
  open,
  onClose,
  appraisalId,
  rowVersion,
  onSuccess,
  onError,
}: SubmitToTalentCommitteeDialogProps) {
  const { mutate, isPending } = useSubmitToTalentCommittee(appraisalId);

  const handleConfirm = () => {
    mutate(
      { rowVersion },
      {
        onSuccess: () => {
          onSuccess();
        },
        onError: (error) => {
          onError(error);
        },
      },
    );
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Submit to Talent Committee</DialogTitle>
      <DialogContent>
        <Typography>
          You are about to submit this appraisal to the Talent Committee. This confirms that your
          review is complete and the appraisal is ready for Talent Committee evaluation.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={onClose} disabled={isPending}>
          Cancel
        </Button>
        <Button onClick={handleConfirm} disabled={isPending}>
          Submit to Talent Committee
        </Button>
      </DialogActions>
    </Dialog>
  );
}
